import React from 'react'
import { outcomeLabel, outcomeTone } from './model'

// What each buyer said about one lead. Every response is reconstructed from
// the Event trail rather than recorded by routing (`inferred`), and the
// tooltip says so.
export default function BuyerResponseChips({ responses, palette }) {
  if (!responses?.length) return <span style={{ color: 'var(--text-muted)' }}>No buyer contacted</span>

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {responses.map((r, i) => {
        const { label } = outcomeLabel(r.outcome)
        const tone = outcomeTone(r.outcome)
        const text = r.code ? `${label}: ${r.code}` : label
        return (
          <span
            key={`${r.buyer}-${i}`}
            title={r.inferred ? 'Inferred from event log' : undefined}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 8px', borderRadius: 999,
              fontSize: 11, border: '1px solid var(--border)', background: 'var(--bg-surface)', whiteSpace: 'nowrap',
            }}
          >
            <span aria-hidden="true" style={{ width: 7, height: 7, borderRadius: 999, background: palette.forLabel(r.buyer) }} />
            <span style={{ color: 'var(--text-primary)', fontWeight: 600 }}>{r.buyer}</span>
            <span style={{ color: tone.fg, fontWeight: 600 }}>{text}</span>
          </span>
        )
      })}
    </div>
  )
}
